var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandMozillaFirefoxStyleBrand = function SvgBrandMozillaFirefoxStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__clip0_3952_114947)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint0_linear_3952_114947)",
    d: "M22.463 8.034c-.504-1.213-1.527-2.523-2.328-2.938A12 12 0 0 1 21.31 8.62l.002.019C20 5.367 17.775 4.048 15.957 1.175a14 14 0 0 1-.273-.444 4 4 0 0 1-.128-.24 2 2 0 0 1-.173-.46.03.03 0 0 0-.027-.03.04.04 0 0 0-.021 0q-.003.002-.006.004L15.32.01l.005-.008C12.41 1.709 11.42 4.869 11.329 6.45a5.8 5.8 0 0 0-3.194 1.23 4 4 0 0 0-.3-.226 5.4 5.4 0 0 1-.032-2.837A8.6 8.6 0 0 0 5.01 6.776h-.005c-.46-.583-.428-2.506-.401-2.907a2 2 0 0 0-.388.205q-.61.436-1.134.972-.597.606-1.085 1.302v.002-.002A9.8 9.8 0 0 0 .438 9.864l-.015.077q-.064.36-.114.725l-.003.025a11 11 0 0 0-.188 1.6v.06c.007 8.936 9.685 14.512 17.42 10.037a11.6 11.6 0 0 0 5.625-8.074q.029-.224.053-.45c.24-1.975-.02-3.98-.753-5.83M9.086 17.12q.08.04.16.079l.009.005zm12.227-8.478V8.63l.002.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint1_radial_3952_114947)",
    d: "M22.463 8.034c-.504-1.213-1.527-2.523-2.328-2.937A12 12 0 0 1 21.31 8.62v.01l.002.013c.895 2.56.766 5.367-.36 7.834-1.331 2.854-4.551 5.78-9.591 5.637C5.915 21.96 1.119 17.92.222 12.626c-.163-.835 0-1.258.082-1.936a8.7 8.7 0 0 0-.186 1.601v.06c.007 8.936 9.685 14.512 17.42 10.037a11.6 11.6 0 0 0 5.625-8.074q.029-.224.053-.45c.24-1.975-.02-3.98-.753-5.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint2_radial_3952_114947)",
    d: "M22.463 8.034c-.504-1.213-1.527-2.523-2.328-2.937A12 12 0 0 1 21.31 8.62v.01l.002.013c.895 2.56.766 5.367-.36 7.834-1.331 2.854-4.551 5.78-9.591 5.637C5.915 21.96 1.119 17.92.222 12.626c-.163-.835 0-1.258.082-1.936a8.7 8.7 0 0 0-.186 1.601v.06c.007 8.936 9.685 14.512 17.42 10.037a11.6 11.6 0 0 0 5.625-8.074q.029-.224.053-.45c.24-1.975-.02-3.98-.753-5.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint3_radial_3952_114947)",
    d: "M16.823 9.399q.038.026.072.053a6.3 6.3 0 0 0-1.078-1.406C12.21 4.438 14.872.223 15.321.008l.004-.006C12.41 1.709 11.421 4.869 11.33 6.45c.135-.01.269-.021.407-.021a5.86 5.86 0 0 1 5.086 2.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint4_radial_3952_114947)",
    d: "M11.745 10.12c-.02.288-1.04 1.284-1.396 1.284-3.3 0-3.836 1.996-3.836 1.996.146 1.682 1.317 3.066 2.734 3.799q.097.05.196.093.168.075.34.14c.486.172.995.27 1.51.291 5.785.272 6.906-6.918 2.731-9.004a4 4 0 0 1 2.799.68 5.86 5.86 0 0 0-5.086-2.97c-.137 0-.272.011-.408.02a5.8 5.8 0 0 0-3.194 1.232c.177.15.377.35.798.764.787.776 2.807 1.58 2.812 1.674"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint5_radial_3952_114947)",
    d: "M11.745 10.12c-.02.288-1.04 1.284-1.396 1.284-3.3 0-3.836 1.996-3.836 1.996.146 1.682 1.317 3.066 2.734 3.799q.097.05.196.093.168.075.34.14c.486.172.995.27 1.51.291 5.785.272 6.906-6.918 2.731-9.004a4 4 0 0 1 2.799.68 5.86 5.86 0 0 0-5.086-2.97c-.137 0-.272.011-.408.02a5.8 5.8 0 0 0-3.194 1.232c.177.15.377.35.798.764.787.776 2.807 1.58 2.812 1.674"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint6_radial_3952_114947)",
    d: "M7.594 7.295q.12.077.24.159A5.4 5.4 0 0 1 7.8 4.617a8.6 8.6 0 0 0-2.794 2.159c.057-.002 1.74-.032 2.587.519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint7_radial_3952_114947)",
    d: "M.224 12.626c.896 5.293 5.693 9.334 11.138 9.488 5.04.143 8.26-2.783 9.59-5.637a10.5 10.5 0 0 0 .362-7.834v-.011q-.002-.014 0-.011l.002.02c.412 2.688-.956 5.292-3.093 7.053l-.007.015c-4.165 3.393-8.15 2.047-8.958 1.498l-.169-.085c-2.428-1.16-3.431-3.373-3.216-5.27a2.98 2.98 0 0 1-2.75-1.73 4.38 4.38 0 0 1 4.267-.171 5.78 5.78 0 0 0 4.358.171c-.004-.094-2.024-.898-2.812-1.674-.42-.415-.62-.614-.797-.764a4 4 0 0 0-.3-.227l-.24-.16c-.846-.55-2.53-.52-2.585-.518h-.005c-.46-.583-.428-2.506-.402-2.907a2 2 0 0 0-.387.205q-.61.436-1.135.972a10 10 0 0 0-1.09 1.299v.002-.002A9.8 9.8 0 0 0 .439 9.864c-.005.024-.418 1.827-.214 2.762"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint8_radial_3952_114947)",
    d: "M15.818 8.046c.423.416.786.89 1.078 1.407a2 2 0 0 1 .174.143c2.631 2.425 1.253 5.855 1.15 6.099 2.137-1.762 3.504-4.366 3.093-7.055C20 5.367 17.775 4.048 15.957 1.175a14 14 0 0 1-.273-.444 4 4 0 0 1-.128-.24 2 2 0 0 1-.18-.48.03.03 0 0 0-.02-.01.04.04 0 0 0-.021 0q-.003.002-.006.004-.004.001-.008.005c-.45.213-3.111 4.428.497 8.036"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint9_radial_3952_114947)",
    d: "M17.068 9.594a2 2 0 0 0-.174-.142q-.035-.027-.072-.053a4 4 0 0 0-2.799-.68c4.175 2.088 3.055 9.276-2.73 9.004a5.2 5.2 0 0 1-1.51-.291 6 6 0 0 1-.342-.14q-.097-.044-.196-.093l.009.005c.806.55 4.791 1.896 8.957-1.497l.007-.015c.104-.243 1.483-3.673-1.15-6.098"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint10_radial_3952_114947)",
    d: "M6.513 13.4s.535-1.996 3.836-1.996c.357 0 1.378-.996 1.396-1.285a5.78 5.78 0 0 1-4.358-.171 4.38 4.38 0 0 0-4.267.171 2.98 2.98 0 0 0 2.75 1.73c-.216 1.898.787 4.11 3.216 5.27q.08.041.16.08C7.83 16.466 6.66 15.082 6.514 13.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandMozillaFirefoxStyleBrand__paint11_linear_3952_114947)",
    d: "M22.463 8.034c-.504-1.213-1.527-2.523-2.328-2.938A12 12 0 0 1 21.31 8.62l.002.019C20 5.367 17.775 4.048 15.957 1.175a14 14 0 0 1-.273-.444 4 4 0 0 1-.128-.24 2 2 0 0 1-.173-.46.03.03 0 0 0-.027-.03.04.04 0 0 0-.021 0q-.003.002-.006.004L15.32.01l.005-.008C12.41 1.709 11.42 4.869 11.329 6.45c.136-.01.27-.021.408-.021a5.86 5.86 0 0 1 5.086 2.97 4 4 0 0 0-2.799-.68c4.175 2.088 3.055 9.276-2.73 9.004a5.2 5.2 0 0 1-1.51-.291 6 6 0 0 1-.342-.14q-.098-.044-.195-.093l.008.005-.17-.084c.055.026.106.054.162.079-1.418-.733-2.588-2.117-2.734-3.799 0 0 .535-1.996 3.836-1.996.357 0 1.377-.996 1.396-1.285-.005-.094-2.025-.898-2.812-1.674-.421-.415-.62-.614-.798-.764a4 4 0 0 0-.3-.227 5.4 5.4 0 0 1-.032-2.837A8.6 8.6 0 0 0 5.01 6.776h-.005c-.46-.583-.428-2.506-.401-2.907a2 2 0 0 0-.388.205q-.61.436-1.134.972-.597.606-1.085 1.302v.002-.002A9.8 9.8 0 0 0 .438 9.864l-.015.077c-.022.102-.12.62-.134.732 0-.008 0 .009 0 0q-.135.805-.171 1.618v.06c.007 8.936 9.685 14.512 17.42 10.037a11.6 11.6 0 0 0 5.625-8.074q.029-.224.053-.45c.24-1.975-.02-3.98-.753-5.83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint1_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(20.037 2.659)scale(24.1967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint2_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.195 12.55)scale(24.1967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint3_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(14.113 -2.833)scale(17.5295)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint4_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(8.519 18.871)scale(11.5211)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint5_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-13.592 50.602 -47.253)scale(6.10841 7.15142)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint6_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(10.89 1.668)scale(8.28826)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint7_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(17.405 -3.589)scale(35.3623)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint8_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(83.976 8.117 7.205)scale(25.9179 17.0097)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint9_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(10.695 4.738)scale(22.0773)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint10_radial_3952_114947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(16.522 6.03)scale(24.1634)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint0_linear_3952_114947",
    x1: 20.927,
    x2: 1.659,
    y1: 3.71,
    y2: 22.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__paint11_linear_3952_114947",
    x1: 20.695,
    x2: 4.3,
    y1: 3.611,
    y2: 20.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandMozillaFirefoxStyleBrand__clip0_3952_114947"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandMozillaFirefoxStyleBrand);
export { ForwardRef as ReactComponent };